import fetchServer from "../fetchServer";

export default async function getAdminTeam({ param, cancelToken, setLoading }) {
  let result = { return: 0, msg: "Something went wrong updating profile!" };
  setLoading?.(true);

  const route = "/main/v1/adminTeam/getAll";
  await fetchServer({
    method: "GET",
    url: `${route}${param ? "?" + param : ""}`,
    cancelToken,
  })
    .then((res) => {
      if (!res?.cancelled) setLoading?.(false);
      if (res?.data && !res?.data?.error) {
        result = { return: 1, msg: "Successfull", data: res.data?.data };
      } else result["msg"] = res?.data?.error || result["msg"];
    })
    .catch((err) => {
      console.log("Network Error!");
    });

  return result;
}
